export default {"src":"/_next/static/media/tw.cb5421e7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};